import { useSelector } from 'react-redux';

import { ApplicationState } from '@app/store';
import { UserRole } from '@app/objects/User';
import { useCrematory } from '@app/hooks/Crematory/useCrematory';

interface ArchiveAccess {
	canAccess: boolean;
}

export function useArchiveAccess(): ArchiveAccess {
	const user = useSelector((state: ApplicationState) => state.login.user);
	const crematory = useCrematory();

	if (user?.role === UserRole.Admin) return { canAccess: true };

	return {
		canAccess: crematory?.archived === false,
	};
}
